import React, { useEffect, useState } from 'react';

const ColorPicker = (props) => {

    const ColorBox = (props) => {
        return (
            <div style={{ width: '20px', height: '20px', padding: '2px' }}>
                <div style={{ backgroundColor: props.color, width: '100%', height: '100%' }}></div>
            </div>
        )
    }

    const colors = ['red', 'blue', 'green', 'yellow', 'purple', 'orange', 'pink', 'brown', 'grey'];


    return (
        <div style={{ display: 'flex' }}>
            {colors.map((color, index) => (
                <div key={index} style={{ margin: '5px', borderWidth: props.selectedColor == color ? '1px' : '0px', borderStyle: 'solid', borderColor: 'grey', cursor: 'pointer' }} onClick={() => { props.setSelectedColor(color) }}>
                    <ColorBox color={color} selected={props.selectedColor == color} />
                </div>
            ))}
        </div>
    );
};

export default ColorPicker;
